<template>
    <div v-if="!!model">
        <rkm-area
            no-margin-top
            title="Filtros"
            type="fieldset"
        >
            <rkm-form
                ref="Form"
                show-legend
            >
                <rkm-row>
                    <rkm-col cols="6">
                        <rkm-form-date-picker
                            :end-validations="validations.periodo"
                            :max-date="additionals.dataAtual"
                            :range-inline="false"
                            :start-validations="validations.periodo"
                            end-label="Até"
                            range
                            start-label="Período de"
                            v-model="model.periodo"
                        />
                    </rkm-col>

                    <rkm-col cols="6">
                        <rkm-form-select
                            :options="form.unidades"
                            @change="handleUnidadeChange"
                            default-option-text="Todas"
                            label="Unidade"
                            show-default-option
                            text-field="nomeFantasia"
                            v-model="model.unidadeId"
                            value-field="id"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col cols="6">
                        <rkm-form-select
                            :options="form.infraestruturas"
                            @change="handleInfraestruturaChange"
                            default-option-text="Todos"
                            label="Local de atendimento"
                            show-default-option
                            text-field="nome"
                            v-model="model.infraestruturaId"
                            value-field="id"
                        />
                    </rkm-col>

                    <rkm-col cols="6">
                        <rkm-form-select
                            :options="form.ocupacoes"
                            @change="handleOcupacaoChange"
                            default-option-text="Todas"
                            label="CBO"
                            show-default-option
                            text-field="nome"
                            v-model="model.ocupacaoId"
                            value-field="id"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col cols="6">
                        <rkm-form-select
                            :options="form.especialidades"
                            @change="handleEspecialidadeChange"
                            default-option-text="Todas"
                            label="Especialidade"
                            show-default-option
                            text-field="nome"
                            v-model="model.especialidadeId"
                            value-field="id"
                        />
                    </rkm-col>

                    <rkm-col cols="6">
                        <rkm-form-select
                            :options="form.usuarios"
                            @change="handleUsuarioChange"
                            default-option-text="Todos"
                            label="Profissional"
                            show-default-option
                            text-field="nome"
                            v-model="model.usuarioId"
                            value-field="id"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col cols="4">
                        <rkm-form-multiselect
                            :options="form.feridas"
                            @update:dropdownClosed="handleFeridaDropdownClosed"
                            label="Ferida"
                            option-name-key="nome"
                            option-text-selecteds="feridas"
                            v-model="model.feridas"
                            value-field="id"
                        />
                    </rkm-col>

                    <rkm-col cols="4">
                        <rkm-form-select
                            :options="form.status"
                            @change="handleStatusChange"
                            default-option-text="Todos"
                            label="Status da ferida"
                            show-default-option
                            v-model="model.status"
                        />
                    </rkm-col>

                    <rkm-col cols="4">
                        <rkm-form-multiselect
                            :options="form.procedimentos"
                            label="Procedimentos"
                            option-name-key="nome"
                            option-text-selecteds="procedimentos"
                            v-model="model.procedimentos"
                            value-field="id"

                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col>
                        <rkm-form-input-autocomplete
                            :disabled="!model.periodo.start || !model.periodo.end"
                            :repository="repositories.relatorioRastreioFerida"
                            :request-query-string-params="requestQueryStringParams"
                            :search-fields="pacienteSearchFields"
                            :text-field="p => `${p.nome}${p.nomeSocial ? ` (${p.nomeSocial})` : ''}${p.cns ? ` - ${p.cns}` : ''}`"
                            label="Paciente"
                            placeholder="Nome, Nome social, CNS, CPF, Data de nascimento ou Prontuário"
                            v-model="model.paciente"
                        />
                    </rkm-col>

                    <rkm-col cols="auto">
                        <rkm-button
                            :label="false"
                            @click="$refs.Form.validate(search)"
                            color="primary"
                        >
                            Buscar
                        </rkm-button>

                        <rkm-button
                            :label="false"
                            @click="reset"
                        >
                            Limpar
                        </rkm-button>
                    </rkm-col>
                </rkm-row>
            </rkm-form>
        </rkm-area>

        <template v-if="itens.length > 0">
            <rkm-area
                no-margin-top
                title="Resultado"
            >
                <template v-slot:trailing>
                    <rkm-dropdown
                        class="mr-2"
                        color="primary"
                        cols="1"
                        menu-class="auto-scroll"
                        no-caret
                        small
                        title="Colunas"
                        v-rkm-tooltip.hover
                    >
                        <template v-slot:button-content>
                            <rkm-icon icon="columns" />
                        </template>

                        <rkm-form-checkbox
                            :indeterminate="indeterminate"
                            @change="selectAll"
                            class="mx-2"
                            v-model="selectedAll"
                        >
                            Todas
                        </rkm-form-checkbox>

                        <rkm-form-checkbox-group
                            :options="optionalColumns"
                            class="mx-2"
                            stacked
                            text-field="label"
                            v-model="selectedCols"
                            value-field="key"
                        />
                    </rkm-dropdown>

                    <rkm-button
                        @click="print"
                        color="info"
                        small
                        title="Imprimir"
                    >
                        <rkm-icon icon="print" />
                    </rkm-button>

                    <rkm-button
                        @click="exportTo"
                        color="info"
                        small
                        title="Exportar"
                    >
                        <rkm-icon icon="file-export" />
                    </rkm-button>
                </template>

                <rkm-table
                    :fields="fields"
                    :items="itens"
                    :sort-by="sortBy"
                    :sort-desc="sortDesc"
                    @sort-changed="onSortChanged"
                >
                    <template v-slot:cell(valorTotal)="item">
                        {{'R$ ' + item.item.valorTotal }}

                        <rkm-icon
                            class="infor"
                            color="secondary"
                            icon="info"
                            small
                            v-rkm-popover.hover.left="{
                                html:true,
                                content: 'Cálculo automático somando valor SIGTAP dos procedimentos vinculados ao atendimento e custo dos materiais utilizados.'
                            }"
                        />
                    </template>
                </rkm-table>
            </rkm-area>

            <rkm-area
                no-margin-top
                title="Totalizadores"
                type="fieldset"
            >
                <rkm-row>
                    <rkm-col cols="3">
                        <rkm-form-input
                            :value="totalizadores.pacientesDistintosAtendidos"
                            disabled
                            label="Pacientes distintos atendidos"
                        />
                    </rkm-col>

                    <rkm-col cols="3">
                        <rkm-form-input
                            :value="totalizadores.atendimentosRealizados"
                            disabled
                            label="Atendimentos realizados"
                        />
                    </rkm-col>

                    <rkm-col cols="3">
                        <rkm-form-input
                            :value="totalizadores.soapsGeradas"
                            disabled
                            label="SOAPs geradas"
                        />
                    </rkm-col>

                    <rkm-col cols="3">
                        <rkm-form-input
                            :value="totalizadores.feridasRegistradas"
                            disabled
                            label="Feridas registradas"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col cols="3">
                        <rkm-form-input
                            :value="totalizadores.procedimentosLancados"
                            disabled
                            label="Procedimentos lançados"
                        />
                    </rkm-col>

                    <rkm-col cols="3">
                        <rkm-form-input
                            :value="totalizadores.kitsMateriaisConsumidos"
                            disabled
                            label="Kits/materiais consumidos"
                        />
                    </rkm-col>

                    <rkm-col cols="3">
                        <rkm-form-input
                            :value="`R$ ${totalizadores.valorCustoMaterial}`"
                            disabled
                            label="Despesas de Material"
                        />
                    </rkm-col>

                    <rkm-col cols="3">
                        <rkm-form-input
                            :value="`R$ ${totalizadores.valorCustoProcedimento}`"
                            disabled
                            label="Despesas de Procedimento"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col cols="3">
                        <rkm-form-input
                            :value="`R$ ${totalizadores.valorCustoTotal}`"
                            disabled
                            label="Valores de custo total"
                        />
                    </rkm-col>
                </rkm-row>
            </rkm-area>
        </template>
    </div>
</template>

<script>
// Mixins.
import { data, error, file, object, repository, stringCase } from '@/mixins'

// Others.
import moment from 'moment'

// Vuex.
import { mapActions } from 'vuex'

export default {
    computed: {
        validations() {
            return {
                periodo: { required: true },
            }
        },
        optionalColumns() {
            return this.columns.filter(c => !(c.fixed || false))
        },
        fields() {
            return this.columns.filter(c => (c.fixed || false) || this.selectedCols.includes(c.key))
        },
        pacienteSearchFields() {
            return [
                { key: 'cadastro_cidadao.nome', searchable: true },
                { key: 'cadastro_cidadao.nomeSocial', searchable: true },
                { key: 'cadastro_cidadao.cns', searchable: true },
                { key: 'cadastro_cidadao.cpf', searchable: true },
                { key: 'cadastro_cidadao.data_nascimento', searchable: true },
                { key: 'cadastro_paciente.prontuario', searchable: true },
            ]
        },
        requestQueryStringParams() {
            return this.camelObjectKeysToSnakeRecursive({
                periodo: {
                    start: this.model.periodo.start ? this.others.moment(this.model.periodo.start).format('DD/MM/YYYY') : null,
                    end: this.model.periodo.end ? this.others.moment(this.model.periodo.end).format('DD/MM/YYYY') : null,
                },
                unidadeId: this.model.unidadeId,
                infraestruturaId: this.model.infraestruturaId,
                ocupacaoId: this.model.ocupacaoId,
                especialidadeId: this.model.especialidadeId,
                usuarioId: this.model.usuarioId,
                feridas: this.model.feridas,
                status: this.model.status,
                procedimentos: this.model.procedimentos,
            })
        },
    },
    created() {
        this.repositories = {
            exportacao: this.getConectaSusRepository('exportacao.ambulatorio'),
            impressao: this.getConectaSusRepository('impressao.ambulatorio'),
            relatorioRastreioFerida: this.getConectaSusRepository('ambulatorio.relatorioRastreioFerida'),
        }
    },
    data() {
        return {
            additionals: null,
            columns: [
                { class: 'col-min', filterByFormatted: true, fixed: true, key: 'data', label: 'Data', sortable: true },
                { key: 'pacienteNome', label: 'Paciente', sortable: true},
                { key: 'pacienteProntuario', label: 'Prontuário', sortable: true},
                { key: 'pacienteDataNascimento', label: 'Data de nascimento', sortable: true},
                { key: 'unidadeNomeFantasia', label: 'Unidade', sortable: true},
                { key: 'usuarioNome', label: 'Profissional', sortable: true},
                { key: 'especialidadeNome', label: 'Especialidade', sortable: true},
                { key: 'ocupacaoCodigo', label: 'CBO', sortable: true},
                { key: 'feridaNome', label: 'Ferida', sortable: true},
                { key: 'status', label: 'Status', sortable: true},
                { key: 'procedimentos', label: 'Procedimento', sortable: true},
                { key: 'materiais', label: 'Materiais', sortable: true},
                { class: 'text-center', key: 'valorTotal', label: 'Custo do atendimento', sortable: true},
            ],
            form: null,
            indeterminate: true,
            itens: [],
            model: null,
            others: {moment},
            selectedAll: false,
            selectedCols: [
                'data',
                'pacienteNome',
                'unidadeNomeFantasia',
                'usuarioNome',
                'feridaNome',
                'cicatrizada',
            ],
            sortBy: 'data',
            sortDesc: false,
            totalizadores: null,
        }
    },
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {
            this.setLoading()

            this.repositories.relatorioRastreioFerida.create()
                .then(response => {
                    this.additionals = Object.assign(response.data.additionals)
                    this.form = Object.assign(response.data.form)
                    this.model = Object.assign(response.data.model)
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        handleUnidadeChange(value) {
            this.form.infraestruturas = []
            this.form.ocupacoes = []
            this.form.especialidades = []
            this.form.usuarios = []
            this.form.feridas = []
            this.form.status = []
            this.form.procedimentos = []

            this.model.infraestruturaId = null
            this.model.ocupacaoId = null
            this.model.especialidadeId = null
            this.model.usuarioId = null
            this.model.feridasId = null
            this.model.status = null
            this.model.procedimentos = []

            this.totalizadores = null
            this.itens = []

            const request = {
                listar: 'infraestruturas',
                periodo: {
                    start: this.model.periodo.start ? this.others.moment(this.model.periodo.start).format('DD/MM/YYYY') : null,
                    end: this.model.periodo.end ? this.others.moment(this.model.periodo.end).format('DD/MM/YYYY') : null,
                },
                unidadeId: value,
            }

            this.setLoading()

            this.repositories.relatorioRastreioFerida.list(this.camelObjectKeysToSnakeRecursive(request))
                .then(response => {
                    this.form.infraestruturas = Object.assign(response.data.infraestruturas)
                    this.form.ocupacoes = Object.assign(response.data.ocupacoes)
                    this.form.especialidades = Object.assign(response.data.especialidades)
                    this.form.usuarios = Object.assign(response.data.usuarios)
                    this.form.feridas = Object.assign(response.data.feridas)
                    this.form.status = Object.assign(response.data.status)
                    this.form.procedimentos = Object.assign(response.data.procedimentos)
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        handleInfraestruturaChange(value) {
            this.form.ocupacoes = []
            this.form.especialidades = []
            this.form.usuarios = []
            this.form.feridas = []
            this.form.status = []
            this.form.procedimentos = []

            this.model.ocupacaoId = null
            this.model.especialidadeId = null
            this.model.usuarioId = null
            this.model.feridasId = null
            this.model.status = null
            this.model.procedimentos = []

            this.totalizadores = null
            this.itens = []

            const request = {
                listar: 'ocupacoes',
                periodo: {
                    start: this.model.periodo.start ? this.others.moment(this.model.periodo.start).format('DD/MM/YYYY') : null,
                    end: this.model.periodo.end ? this.others.moment(this.model.periodo.end).format('DD/MM/YYYY') : null,
                },
                unidadeId: this.model.unidadeId,
                infraestruturaId: value,
            }

            this.setLoading()

            this.repositories.relatorioRastreioFerida.list(this.camelObjectKeysToSnakeRecursive(request))
                .then(response => {
                    this.form.ocupacoes = Object.assign(response.data.ocupacoes)
                    this.form.especialidades = Object.assign(response.data.especialidades)
                    this.form.usuarios = Object.assign(response.data.usuarios)
                    this.form.feridas = Object.assign(response.data.feridas)
                    this.form.status = Object.assign(response.data.status)
                    this.form.procedimentos = Object.assign(response.data.procedimentos)
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        handleOcupacaoChange(value) {
            this.form.especialidades = []
            this.form.usuarios = []
            this.form.feridas = []
            this.form.status = []
            this.form.procedimentos = []

            this.model.especialidadeId = null
            this.model.usuarioId = null
            this.model.feridasId = null
            this.model.status = null
            this.model.procedimentos = []

            this.totalizadores = null
            this.itens = []

            const request = {
                listar: 'especialidades',
                periodo: {
                    start: this.model.periodo.start ? this.others.moment(this.model.periodo.start).format('DD/MM/YYYY') : null,
                    end: this.model.periodo.end ? this.others.moment(this.model.periodo.end).format('DD/MM/YYYY') : null,
                },
                unidadeId: this.model.unidadeId,
                infraestruturaId: this.model.infraestruturaId,
                ocupacaoId: value,
            }

            this.setLoading()

            this.repositories.relatorioRastreioFerida.list(this.camelObjectKeysToSnakeRecursive(request))
                .then(response => {
                    this.form.especialidades = Object.assign(response.data.especialidades)
                    this.form.usuarios = Object.assign(response.data.usuarios)
                    this.form.feridas = Object.assign(response.data.feridas)
                    this.form.status = Object.assign(response.data.status)
                    this.form.procedimentos = Object.assign(response.data.procedimentos)
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        handleEspecialidadeChange(value) {
            this.form.usuarios = []
            this.form.feridas = []
            this.form.status = []
            this.form.procedimentos = []

            this.model.usuarioId = null
            this.model.feridasId = null
            this.model.status = null
            this.model.procedimentos = []

            this.totalizadores = null
            this.itens = []

            const request = {
                listar: 'usuarios',
                periodo: {
                    start: this.model.periodo.start ? this.others.moment(this.model.periodo.start).format('DD/MM/YYYY') : null,
                    end: this.model.periodo.end ? this.others.moment(this.model.periodo.end).format('DD/MM/YYYY') : null,
                },
                unidadeId: this.model.unidadeId,
                infraestruturaId: this.model.infraestruturaId,
                ocupacaoId: this.model.ocupacaoId,
                especialidadeId: value,
            }

            this.setLoading()

            this.repositories.relatorioRastreioFerida.list(this.camelObjectKeysToSnakeRecursive(request))
                .then(response => {
                    this.form.usuarios = Object.assign(response.data.usuarios)
                    this.form.feridas = Object.assign(response.data.feridas)
                    this.form.status = Object.assign(response.data.status)
                    this.form.procedimentos = Object.assign(response.data.procedimentos)
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        handleUsuarioChange(value) {
            this.form.feridas = []
            this.form.status = []
            this.form.procedimentos = []

            this.model.feridasId = null
            this.model.status = null
            this.model.procedimentos = []

            this.totalizadores = null
            this.itens = []

            const request = {
                listar: 'feridas',
                periodo: {
                    start: this.model.periodo.start ? this.others.moment(this.model.periodo.start).format('DD/MM/YYYY') : null,
                    end: this.model.periodo.end ? this.others.moment(this.model.periodo.end).format('DD/MM/YYYY') : null,
                },
                unidadeId: this.model.unidadeId,
                infraestruturaId: this.model.infraestruturaId,
                ocupacaoId: this.model.ocupacaoId,
                especialidadeId: this.model.especialidadeId,
                usuarioId: value,
            }

            this.setLoading()

            this.repositories.relatorioRastreioFerida.list(this.camelObjectKeysToSnakeRecursive(request))
                .then(response => {
                    this.form.feridas = Object.assign(response.data.feridas)
                    this.form.status = Object.assign(response.data.status)
                    this.form.procedimentos = Object.assign(response.data.procedimentos)
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        handleFeridaDropdownClosed() {
            this.form.status = []
            this.form.procedimentos = []

            this.model.status = null
            this.model.procedimentos = []

            this.totalizadores = null
            this.itens = []

            const request = {
                listar: 'status',
                periodo: {
                    start: this.model.periodo.start ? this.others.moment(this.model.periodo.start).format('DD/MM/YYYY') : null,
                    end: this.model.periodo.end ? this.others.moment(this.model.periodo.end).format('DD/MM/YYYY') : null,
                },
                unidadeId: this.model.unidadeId,
                infraestruturaId: this.model.infraestruturaId,
                ocupacaoId: this.model.ocupacaoId,
                especialidadeId: this.model.especialidadeId,
                usuarioId: this.model.usuarioId,
                feridas: this.model.feridas,
            }

            this.setLoading()

            this.repositories.relatorioRastreioFerida.list(this.camelObjectKeysToSnakeRecursive(request))
                .then(response => {
                    this.form.status = Object.assign(response.data.status)
                    this.form.procedimentos = Object.assign(response.data.procedimentos)
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        handleStatusChange(value) {
            this.form.procedimentos = []

            this.model.procedimentos = []

            this.totalizadores = null
            this.itens = []

            const request = {
                listar: 'procedimentos',
                periodo: {
                    start: this.model.periodo.start ? this.others.moment(this.model.periodo.start).format('DD/MM/YYYY') : null,
                    end: this.model.periodo.end ? this.others.moment(this.model.periodo.end).format('DD/MM/YYYY') : null,
                },
                unidadeId: this.model.unidadeId,
                infraestruturaId: this.model.infraestruturaId,
                ocupacaoId: this.model.ocupacaoId,
                especialidadeId: this.model.especialidadeId,
                usuarioId: this.model.usuarioId,
                feridas: this.model.feridas,
                status: value
            }

            this.setLoading()

            this.repositories.relatorioRastreioFerida.list(this.camelObjectKeysToSnakeRecursive(request))
                .then(response => this.form.procedimentos = Object.assign(response.data.procedimentos))
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        search() {
            this.setLoading()

            this.repositories.relatorioRastreioFerida.index(this.prepareData())
                .then(response => {
                    this.totalizadores = Object.assign(response.data.totalizadores)
                    this.itens = Object.assign(response.data.itens)
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        reset() {
            this.form.unidades = []
            this.form.infraestruturas = []
            this.form.ocupacoes = []
            this.form.especialidades = []
            this.form.usuarios = []
            this.form.feridas = []
            this.form.status = []
            this.form.procedimentos = []

            this.model.unidadeId = null
            this.model.infraestruturaId = null
            this.model.ocupacaoId = null
            this.model.especialidadeId = null
            this.model.usuarioId = null
            this.model.feridasId = null
            this.model.status = null
            this.model.procedimentos = []

            this.totalizadores = null
            this.itens = []

            this.$nextTick().then(() => this.$refs.Form.resetValidator())
        },
        print() {
            this.setLoading()

            this.repositories.impressao.relatorioRastreioFerida(this.prepareDataWithColumns())
                .then(({ data, headers }) => this.openFile(data, headers['content-type']))
                .finally(() => this.unsetLoading())
        },
        exportTo() {
            this.setLoading()

            this.repositories.exportacao.relatorioRastreioFerida(this.prepareDataWithColumns())
                .then(({ data, headers }) => this.openFile(data, headers['content-type']))
                .finally(() => this.unsetLoading())
        },
        selectAll(selected) {
            this.selectedCols = selected ? this.optionalColumns.map(c => c.key) : []
        },
        onSortChanged(context) {
            this.sortBy = context.sortBy
            this.sortDesc = context.sortDesc
        },
        prepareData() {
            const data = this.clone(this.model)

            data.sortBy = this.sortBy ? this.camelToSnake(this.sortBy) : null
            data.sortDesc = this.sortDesc

            this.formateDates(data.periodo, ['start', 'end'], 'DD/MM/YYYY')

            return this.camelObjectKeysToSnakeRecursive(data)
        },
        prepareDataWithColumns() {
            const data = this.prepareData()

            data.columns = this.fields.map(f => ({
                key: this.camelToSnake(f.key),
                label: f.label,
                class: f.class
            }))

            return data
        },
    },
    mixins: [data,error, file,  object, repository, stringCase],
    mounted() {
        this.load()
    },
    watch: {
        'model.periodo': {
            deep: true,
            handler(value) {
                this.form.unidades = []
                this.form.infraestruturas = []
                this.form.ocupacoes = []
                this.form.especialidades = []
                this.form.usuarios = []
                this.form.feridas = []
                this.form.status = []
                this.form.procedimentos = []

                this.model.unidadeId = null
                this.model.infraestruturaId = null
                this.model.ocupacaoId = null
                this.model.especialidadeId = null
                this.model.usuarioId = null
                this.model.feridasId = null
                this.model.status = null
                this.model.procedimentos = []

                this.totalizadores = null
                this.itens = []

                if (value.start === null || value.end === null)  {
                    return
                }

                const request = {
                    listar: 'unidades',
                    periodo: {
                        start: this.others.moment(value.start).format('DD/MM/YYYY'),
                        end: this.others.moment(value.end).format('DD/MM/YYYY'),
                    },
                }

                this.setLoading()

                this.repositories.relatorioRastreioFerida.list(this.camelObjectKeysToSnakeRecursive(request))
                    .then(response => {
                        this.form.unidades = Object.assign(response.data.unidades)
                        this.form.infraestruturas = Object.assign(response.data.infraestruturas)
                        this.form.ocupacoes = Object.assign(response.data.ocupacoes)
                        this.form.especialidades = Object.assign(response.data.especialidades)
                        this.form.usuarios = Object.assign(response.data.usuarios)
                        this.form.feridas = Object.assign(response.data.feridas)
                        this.form.status = Object.assign(response.data.status)
                        this.form.procedimentos = Object.assign(response.data.procedimentos)
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
            },
        },
    },
}
</script>